
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import "../Foundation/stylable/default-scroll-bar.st.css.js";
import "../ListItemSelect/ListItemSelect.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_DropdownLayout";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_DropdownLayout__root","heading-h6":"wds_1_76_1_StylableTypography__heading-h6","text-medium-normal":"wds_1_76_1_StylableTypography__text-medium-normal","defaultScrollBar":"wds_1_76_1_defaultscrollbar__defaultScrollBar","contentContainer":"wds_1_76_1_DropdownLayout__contentContainer","options":"wds_1_76_1_DropdownLayout__options","option":"wds_1_76_1_DropdownLayout__option","selectableOption":"wds_1_76_1_DropdownLayout__selectableOption","arrow":"wds_1_76_1_DropdownLayout__arrow","loader":"wds_1_76_1_DropdownLayout__loader","linkItem":"wds_1_76_1_DropdownLayout__linkItem"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"option_height":"36px","big_option_height":"47px","top-arrow-size":"8px","arrowUpShadow":"3px 3px 8px rgba(0, 0, 0, .1)","arrowDownShadow":"-3px -3px 8px rgba(0, 0, 0, .1)"}; 
export var vars = {}; 




